<template>
  <footer>
    <v-footer padless class=" px-6 py-3 mt-10 border-top" >
       <v-container class="px-6">
        <v-layout row wrap justify-space-around class="">
          <v-flex xs12 sm6 md7 lg7 xl7 class="text-md-left" align-self-center>
            <router-link :to="'/'" class="primary--text pa-4">
              Home
            </router-link>
            <router-link :to="'/terms-condition'" class="primary--text pa-4">
              Terms & Conditions
            </router-link>

            <router-link :to="'/privacy-policy'" class="primary--text pa-4">
              Privacy Policy
            </router-link>
            <router-link :to="'/contact-us'" class="primary--text pa-4">
              Contact Us
            </router-link>
          </v-flex>

          <v-flex xs12 sm6 md5 lg5 xl5 class="text-right" align-self-center>
            <v-btn
              icon
              link
              href="https://www.facebook.com/freeonlinetool0"
              target="_blank"
              color="primary"
              
            
            >
              <v-icon size="20">mdi-facebook</v-icon></v-btn
            >
            <v-btn
              icon
              link
              href="https://www.instagram.com/freeonlinetool"
              target="_blank"
              color="primary"
              
            >
              <v-icon size="20">mdi-instagram</v-icon></v-btn
            >
            <v-btn
              icon
              link
              href="https://twitter.com/FreeOnlineTool0"
              target="_blank"
              color="primary"
            >
              <v-icon size="20">mdi-twitter</v-icon></v-btn
            >
            <v-btn
              icon
              link
              href="https://www.linkedin.com/company/free-online-tool"
              target="_blank"
              color="primary"
            >
              <v-icon size="20">mdi-linkedin</v-icon></v-btn
            >
            <v-btn
              icon
              link
              href="https://www.youtube.com/@freeonlinetool"
              target="_blank"
              color="primary"
            >
              <v-icon size="20">mdi-youtube</v-icon></v-btn
            >
            <span class="ml-2">
               Free Online Tool  -
              <v-icon size="18">mdi-copyright</v-icon>
              {{ new Date().getFullYear() }}
            </span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </footer>
</template>
<script>
export default {
  name: "FooterSection",
  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
  }),
};
</script>
<style lang="scss" scoped>
@import "../scss/main.scss";
a {
  color: rgb(226, 226, 226) !important;
  text-decoration: none !important;
  font-weight: 400 !important;
  margin: 0px !important;
  font-size: 1rem;
}
</style>
